import { baseUniDriverFactory } from '../test-utils/utils/unidriver';

export const verticalTabsItemDriverFactory = base => {
  return {
    ...baseUniDriverFactory(base),

    /** Get the item's text */
    getText: async () => base.$('[data-hook="vertical-tabs-item-text"]').text(),

    /** Keydown with Enter key */
    pressEnterKey: async () => base.pressKey('Enter'),
  };
};
